import debug from 'debug';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-swatch-row]';
const PLUGIN_NAME = 'SwatchRow';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "swatch-row" */ './swatch-row'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});

	$(document).on('product-teasers-loaded', function(){
		$(ELEMENT_SELECTOR).each(function() {
			const element = this;
			System.import(
				/* webpackChunkName: "swatch-row" */ './swatch-row'
			).then((module) => {
				plugin(PLUGIN_NAME, module.default);
				$(element)[PLUGIN_NAME]();
			});
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/swatch-row/swatch-row--split.js